import request from '@/api/request'

// 创建订单
export function createOrder(data) {
  return request.post('/api/mini/order/create', data)
}

// 获取订单列表
export function getOrderList(params) {
  return request.get('/api/mini/order/list', { params })
}

// 获取订单详情
export function getOrderDetail(id) {
  return request.get(`/api/mini/order/detail/${id}`)
}

// 取消订单
export function cancelOrder(id) {
  return request.post(`/api/mini/order/cancel/${id}`)
}

// 申请退款
export function applyRefund(id) {
  return request.post(`/api/mini/order/apply-refund/${id}`)
}

// 发起微信 H5 支付，返回 { alreadyPaid, h5Url }
export function payOrderH5(id) {
  return request.post(`/api/mini/order/pay-h5/${id}`)
}

// 查询支付状态（用于支付跳回后轮询确认）
export function getPayStatus(id) {
  return request.get(`/api/mini/order/pay-status/${id}`)
}
